import path from "ramda/es/path";
import identity from "ramda/es/identity";
import memoizeWith from "ramda/es/memoizeWith";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/formData';
import { getFieldValue } from '../../utils/index';
import { getTemporaryFormData } from '../temporaryStore';
/**
 * get formData for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getFormData('formName')(state)
 *
 */ export const getFormData = memoizeWithIdentity((formName)=>createSelector(path([
        formName,
        REDUCER_NAME
    ]), identity));
/**
 * get value from formData for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getFormData('formName')(state)({deepPath, temp})
 *
 */ export const getFormDataValue = memoizeWithIdentity((formName)=>createSelector([
        getFormData(formName),
        getTemporaryFormData(formName)
    ], (formData, temporaryData)=>memoizeWith(JSON.stringify, (descriptor)=>getFieldValue(descriptor, formData, temporaryData))));
